<template>
  <form v-on:submit.prevent="submitForm">

    <h2>Countries</h2>
    <div class="form-group"><label for="id">ID :</label><input class="form-control" id="id" readonly="readonly" v-model="country.id"/></div>
    <div class="form-group"><label for="name">Name : </label><input class="form-control" id="name" v-model="country.name"/></div>
    <div class="form-group"><label for="code">Code : </label><input class="form-control" id="code" v-model="country.code"/></div>
    <div class="form-group"><label for="thirdIdCountry">Third Id Country : </label><input class="form-control" id="thirdIdCountry" v-model="country.thirdIdCountry"/></div>
    <div class="form-group"><label for="begin">Begin : </label><input class="form-control" id="begin" v-model="country.begin"/></div>
    <div class="form-group"><label for="end">End : </label><input class="form-control" id="end" v-model="country.end"/></div>
    <div class="form-group" v-if="!isCurrencyNull(country)"><label for="currency">Currency : </label>
      <input class="form-control" id="currency" v-model="country.currency.currencyCode"/>
    </div>
    <div v-if="isCurrencyNull(country)">
      No Country associated to this country
    </div>
    <div>
      <p>
        <input class="btn btn-edit" type="submit" value="Submit">
      </p>

      <p class="btn btn-deprecate" @click="deprecateCountry()">
        <v-icon> mdi-clock </v-icon>
        <input class="btn" value="Deprecate">
      </p>

      <p>
        <router-link class="btn btn-cancel" v-bind:to="{path: 'countries'}">
          <v-icon>mdi-cancel</v-icon>
          <input class="btn" type="submit" value="Cancel">
        </router-link>
      </p>

    </div>
  </form>
</template>

<script>
import {parameters} from "../../parameters";
import {httpClient} from "../../requesters/httpClient";

export default {
  name: 'EditCountry',

  async created() {
    await httpClient.get(`${parameters.posdataRefUrl}/countries/` + this.$route.query.id)
      .then((response)=> {
        this.country = response.data;
      })
      .catch((error)=> {
        throw error;
      });
  },
  data() {
    return {
      country : null
    }
  },
  methods: {
    isCurrencyNull: function(country){
      return country.currency === null;
    },
    async submitForm(e) {

      if (!this.areFieldsEmpty()) {
        await httpClient.post(`${parameters.posdataRefUrl}/overwrite/country`, this.country);

        await this.$alert("The country was overwritten THEN updated");

        await this.$router.push('countries');

        e.preventDefault();
      } else {
        await this.$alert("Some mandatory fields are empty");
      }
    },
    areFieldsEmpty: function(){
      if (this.country.name === '' || this.country.code === ''
        || this.country.thirdIdCountry === '' || this.country.currency.currencyCode === ''){
        return true;
      }
    },
    async deprecateCountry(){
      await httpClient.post(`${parameters.posdataRefUrl}/country/` + this.country.id + `/deprecate`)
        .then(function (response){
          if (response.status === 200){
            alert("The country was deprecated")
          } else {
            alert("Country is not present in database and can't be deprecated")
          }

        })
      await this.$router.push('countries')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/countries/EditCountry.vue